import { rolesDescription } from "../../../../components/Utils/Descriptions";

const roleDescriptionById = Object.fromEntries(
	rolesDescription.map((roleDescription) => [roleDescription.id, roleDescription.name]),
);

export function normalizeRoleId(roleId) {
	return String(roleId || "").trim().toUpperCase();
}

export function isTARole(role) {
	return normalizeRoleId(role?.class_role) === "TA";
}

function isSurveySubmission(course) {
	return course?.evaluate !== "No" && normalizeRoleId(course?.form) !== "EXCL";
}

export function courseHasMixedTARoles(course) {
	if (!isSurveySubmission(course)) {
		return false;
	}

	const courseRoles = Array.isArray(course?.roles) ? course.roles : [];
	const hasTA = courseRoles.some(isTARole);
	const hasNonTA = courseRoles.some((role) => normalizeRoleId(role.class_role) !== "TA");

	return hasTA && hasNonTA;
}

export function getMixedTARoleCourses(courses = []) {
	return courses.filter(courseHasMixedTARoles);
}

export function summarizeRolesForCourses(courses = []) {
	const roleMap = new Map();

	courses.forEach((course) => {
		const countedRolesForCourse = new Set();
		const courseRoles = Array.isArray(course?.roles) ? course.roles : [];

		courseRoles.forEach((role) => {
			const roleId = normalizeRoleId(role.class_role);
			if (!roleId) {
				return;
			}

			const existingRole = roleMap.get(roleId) || {
				roleId,
				roleDescription: role.role_description || roleDescriptionById[roleId] || roleId,
				instructorCount: 0,
				courseCount: 0,
			};

			existingRole.instructorCount += 1;
			if (!countedRolesForCourse.has(roleId)) {
				existingRole.courseCount += 1;
				countedRolesForCourse.add(roleId);
			}

			roleMap.set(roleId, existingRole);
		});
	});

	return Array.from(roleMap.values()).sort((leftRole, rightRole) => {
		if (leftRole.roleId === "TA") return -1;
		if (rightRole.roleId === "TA") return 1;
		return leftRole.roleId.localeCompare(rightRole.roleId);
	});
}

export function removeRoleFromCourse(course, roleIdToRemove) {
	const normalizedRoleIdToRemove = normalizeRoleId(roleIdToRemove);
	const currentRoles = Array.isArray(course?.roles) ? course.roles : [];

	return currentRoles.filter(
		(role) => normalizeRoleId(role.class_role) !== normalizedRoleIdToRemove,
	);
}
